import { LifeBuoy } from "lucide-react";
import type { SupportSessionDto } from "@/shared/api/types";
import { Icon } from "@/shared/ui/icon";
import { formatOrgTime } from "@/shared/utils/dates";

/** `operatorName` and `expiresAt` (when the read-only session ends, 30 minutes from the switch) as /me reports them. */
interface SupportBannerProps extends SupportSessionDto {
  tz: string;
}

/** Shown while a Nexborg operator views the organisation through a read-only support session (ADR-0009 §7). */
export function SupportBanner({ operatorName, expiresAt, tz }: SupportBannerProps) {
  const who = operatorName ? `Nexborg support (${operatorName})` : "Nexborg support";
  return (
    <div
      role="status"
      className="flex items-center gap-2.5 border-b border-info/40 bg-info-soft px-4 py-2 text-cell text-info-fg md:px-6"
    >
      <Icon icon={LifeBuoy} size={16} />
      <p className="min-w-0 flex-1">
        {who} is viewing this organisation read-only until {formatOrgTime(expiresAt, tz)}.
      </p>
    </div>
  );
}
